'use client'

import { useEffect, useState } from "react";
import ReactPaginate from 'react-paginate';
import { FallBackImage } from "../commons/fallback-image";
import { NumericFormat } from "react-number-format";
import { fetchGetAdsFilters, fetchGetAdsFilterModelByBrand } from "@/services/api";
import { useRouter, useSearchParams, usePathname } from "next/navigation";
import { useForm } from "react-hook-form";

export default function StockInventoryListing({ ads, page, pageSize, company }) {
    const router = useRouter();
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const pageCount = Math.ceil(ads.paginationOut.totalRows / pageSize);
    const { handleSubmit, setValue } = useForm();
    const [filters, setFilters] = useState({ isLoading: true, brands: [], models: [], yearsModel: [], transmissions: [], fuels: [] });
    const [filterBrand, setFilterBrand] = useState({ isLoading: false, brand: "" });

    useEffect(() => {
        if ($("#sticker-sidebar").length) {
            if ($(window).width() > 991) {
                $("#sticker-sidebar").stick_in_parent({ offset_top: 100 });
            }
        }
    }, [])

    useEffect(() => {
        if (filters.isLoading) {
            fetchGetAdsFilters({ condition: null })
                .then(res => {
                    if (res) { setFilters({ isLoading: false, ...res }); }
                })
                .catch(() => { setFilters({ ...filters, isLoading: false }); });
        }
    }, [filters]);

    const handlePageClick = (event) => {
        let query = {};
        for (const [key, value] of searchParams.entries()) {
            query[key] = value;
        }
        query.pag = event.selected;
        router.push(`${pathname}?${new URLSearchParams(query)}`)
    };

    const handleOrderChange = ({ order }) => {
        let query = {};
        for (const [key, value] of searchParams.entries()) {
            query[key] = value;
        }
        query.ordem = order;
        query.pag = 0;
        router.push(`${pathname}?${new URLSearchParams(query)}`)
    }

    const handleBrandChange = (event) => {
        let idBrand = event.target.value;
        if (idBrand)
            setFilterBrand({ ...filterBrand, isLoading: true, brand: idBrand });
        else setFilters({ ...filters, isLoading: true });
    }

    useEffect(() => {
        if (filterBrand.isLoading) {
            fetchGetAdsFilterModelByBrand({ brand: filterBrand.brand })
                .then(res => {
                    if (res) { setFilters(prevFilters => ({ ...prevFilters, isLoading: false, models: res.models })); }
                    setFilterBrand({ ...filterBrand, isLoading: false });
                })
                .catch(() => { setFilterBrand({ ...filterBrand, isLoading: false }); });
        }
        setValue('ddlModel', "");
    }, [filterBrand, filters, setValue]);

    const onSubmit = () => {
        const ddlBrand = $('#ddlBrand')[0].value;
        const ddlModel = $('#ddlModel')[0].value;
        const ddlPriceFrom = $('#ddlPriceFrom')[0].value;
        const ddlPriceTo = $('#ddlPriceTo')[0].value;
        let query = {};
        for (const [key, value] of searchParams.entries()) {
            query[key] = value;
        }
        query.pag = 0;
        if (ddlBrand) query.marca = ddlBrand; else delete query.marca;
        if (ddlModel) query.modelo = ddlModel; else delete query.modelo;
        if (ddlPriceFrom) query.preco_de = ddlPriceFrom; else delete query.preco_de;
        if (ddlPriceTo) query.preco_ate = ddlPriceTo; else delete query.preco_ate;
        pathname === '/novos' ?
            router.push(`/novos?${new URLSearchParams(query)}`)
            :
            pathname === '/seminovos' ?
                router.push(`/seminovos?${new URLSearchParams(query)}`)
                :
                pathname === '/blindados' ?
                    router.push(`/blindados?${new URLSearchParams(query)}`)
                    :
                    router.push(`/estoque?${new URLSearchParams(query)}`)
    }

    return (
        <section className="content-sm">
            <div className="auto-container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-3">
                                <div id="sticker-sidebar">
                                    <aside>
                                        <div className="sidebar">
                                            <div className="col-md-12">
                                                <div className="site-heading text-left">
                                                    <h2>PESQUISAR</h2>
                                                    <p></p>
                                                </div>
                                                <div className="clearfix d-block w-100 theme-mb-10"></div>
                                                <form onSubmit={handleSubmit(onSubmit)}>
                                                    <div className="row sidebar-search">
                                                        <div
                                                            className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 theme-mb-20">
                                                            <div className="form-group">
                                                                <i className="mdi mdi-menu"></i>
                                                                <select id="ddlBrand" className="nice-select" onChange={handleBrandChange}>
                                                                    <option value="">Marca</option>
                                                                    {filters.brands.map((item, index) => <option value={item.name} key={index}>{item.name.toUpperCase()}</option>)}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div
                                                            className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 theme-mb-20">
                                                            <div className="form-group">
                                                                <i className="mdi mdi-car"></i>
                                                                <select id="ddlModel" className="nice-select">
                                                                    <option value="">Modelo</option>
                                                                    {filters.models.map((item, index) => <option value={item.name} key={index}>{item.name.toUpperCase()}</option>)}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div
                                                            className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 theme-mb-20">
                                                            <div className="form-group">
                                                                <i className="mdi mdi-cash"></i>
                                                                <select id="ddlPriceFrom" className="nice-select">
                                                                    <option value=''>Valor De</option>
                                                                    <option value='10000'>R$ 10.000,00</option>
                                                                    <option value='20000'>R$ 20.000,00</option>
                                                                    <option value='30000'>R$ 30.000,00</option>
                                                                    <option value='40000'>R$ 40.000,00</option>
                                                                    <option value='50000'>R$ 50.000,00</option>
                                                                    <option value='60000'>R$ 60.000,00</option>
                                                                    <option value='70000'>R$ 70.000,00</option>
                                                                    <option value='80000'>R$ 80.000,00</option>
                                                                    <option value='90000'>R$90.000,00</option>
                                                                    <option value='100000'>R$ 100.000,00</option>
                                                                    <option value='200000'>R$ 200.000,00</option>
                                                                    <option value='300000'>R$ 300.000,00</option>
                                                                    <option value='400000'>R$ 400.000,00</option>
                                                                    <option value='500000'>R$ 500.000,00</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div
                                                            className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 theme-mb-20">
                                                            <div className="form-group">
                                                                <i className="mdi mdi-cash"></i>
                                                                <select id="ddlPriceTo" className="nice-select">
                                                                    <option value=''>Valor Até</option>
                                                                    <option value='10000'>R$ 10.000,00</option>
                                                                    <option value='20000'>R$ 20.000,00</option>
                                                                    <option value='30000'>R$ 30.000,00</option>
                                                                    <option value='40000'>R$ 40.000,00</option>
                                                                    <option value='50000'>R$ 50.000,00</option>
                                                                    <option value='60000'>R$ 60.000,00</option>
                                                                    <option value='70000'>R$ 70.000,00</option>
                                                                    <option value='80000'>R$ 80.000,00</option>
                                                                    <option value='90000'>R$90.000,00</option>
                                                                    <option value='100000'>R$ 100.000,00</option>
                                                                    <option value='200000'>R$ 200.000,00</option>
                                                                    <option value='300000'>R$ 300.000,00</option>
                                                                    <option value='400000'>R$ 400.000,00</option>
                                                                    <option value='500000'>R$ 500.000,00</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div
                                                            className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 theme-mb-20">
                                                            <button type="submit" name="SendPostFormSearch" value="SendPostFormSearch" className="btn btn-orange btn-arrow">
                                                                <span>PESQUISAR <i className="mdi mdi-magnify"></i></span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </form>
                                                <div className="clearfix d-block w-100 theme-mb-30"></div>
                                            </div>
                                        </div>
                                    </aside>
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-9">
                                <div className="row">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 theme-mb-30">
                                        <div className="option-bar clearfix">
                                            <div className="sorting-options float-right">
                                                <button title="Ordernar do preço menor para o maior" className="change-view-btn" onClick={() => { handleOrderChange({ order: 'LOWEST_PRICE' }); }}>
                                                    <i className="mdi mdi-arrow-down"></i>
                                                    <span>Menor Preço</span>
                                                </button>
                                                <button title="Ordernar do preço maior para o menor" className="change-view-btn" onClick={() => { handleOrderChange({ order: 'BIGGEST_PRICE' }); }}>
                                                    <i className="mdi mdi-arrow-up"></i>
                                                    <span>Maior Preço</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row masonry-items-container">
                                    {
                                        ads.items.length > 0
                                            ? ads.items.map((item, index) => {
                                                const adLink = `anuncio/${item.category}/${`${item.brand.split(' ').join('-').toLowerCase()}-${item.model.split(' ').join('-').toLowerCase()}`}/${item.yearModel}/${item.id}`;
                                                const adTitle = `${item.brand} ${item.model}`;
                                                const message = `Olá, gostaria de informações sobre ${item.brand} ${item.model} - Link do Veículo: ${adLink}`;
                                                const adWhatsapp = `https://api.whatsapp.com/send?phone=55${company.whatsapp}&text=${company.whatsappDefaultMessage ? company.whatsappDefaultMessage : message}`;

                                                return <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4  masonry-item theme-mb-30" key={index}>
                                                    <div className="filter-card-item position-relative overflow-hidden rounded bg-white">
                                                        <a href={adLink} title={adTitle} className="icon-btn compare-btn position-absolute">
                                                            <i className="mdi mdi-plus"></i>
                                                        </a>
                                                        <a href={adWhatsapp} title={adTitle} target="_blank" className="icon-btn wish-btn position-absolute">
                                                            <i className="mdi mdi-whatsapp"></i>
                                                        </a>
                                                        <span className="date position-absolute">{`${item.yearFabrication} - ${item.yearModel}`}</span>
                                                        <div className="feature-thumb position-relative overflow-hidden" style={{ height: '220px' }}>
                                                            <a href={adLink} title={adTitle}>
                                                                <FallBackImage
                                                                    className='img-fluid'
                                                                    style={{
                                                                        width: '100%',
                                                                        objectFit: 'cover',
                                                                        position: 'absolute'
                                                                    }}
                                                                    alt={adTitle}
                                                                    title={adTitle}
                                                                    src={item.mainPhoto ? item.mainPhoto : "/image/no-image.jpeg"} />
                                                            </a>
                                                        </div>
                                                        <div className="filter-card-content">
                                                            <div className="price-btn text-start position-relative">
                                                                {item.promotionalPrice ?
                                                                    <div>
                                                                        <NumericFormat
                                                                            className="small-btn-meta"
                                                                            style={{ fontSize: '14px' }}
                                                                            value={item.price ? item.price : null}
                                                                            displayType={'text'}
                                                                            thousandSeparator="."
                                                                            decimalSeparator=","
                                                                            decimalScale={2}
                                                                            fixedDecimalScale={true}
                                                                            prefix={'De R$ '} />
                                                                        <br />
                                                                        <NumericFormat
                                                                            className="small-btn-meta"
                                                                            style={{ fontSize: '14px' }}
                                                                            value={item.promotionalPrice ? item.promotionalPrice : null}
                                                                            displayType={'text'}
                                                                            thousandSeparator="."
                                                                            decimalSeparator=","
                                                                            decimalScale={2}
                                                                            fixedDecimalScale={true}
                                                                            prefix={'Por R$ '} />
                                                                    </div>
                                                                    :
                                                                    <span className="small-btn-meta">
                                                                        {
                                                                            item.price ?
                                                                                <NumericFormat
                                                                                    className="small-btn-meta"
                                                                                    style={{ fontSize: '14px' }}
                                                                                    value={item.price ? item.price : null}
                                                                                    displayType={'text'}
                                                                                    thousandSeparator="."
                                                                                    decimalSeparator=","
                                                                                    decimalScale={2}
                                                                                    fixedDecimalScale={true}
                                                                                    prefix={'R$ '} />
                                                                                : 'consulte-nos'
                                                                        }
                                                                    </span>}
                                                            </div>
                                                            <span className="meta-content mt-2 d-block"><strong>{item.brand}</strong></span>
                                                            <a href={adLink} title={adTitle} className="mt-1 d-block">
                                                                <h5
                                                                    style={{
                                                                        textOverflow: 'ellipsis',
                                                                        overflow: 'hidden',
                                                                        display: 'inline-block',
                                                                        width: '100%'
                                                                    }}>{item.version}</h5>
                                                            </a>
                                                            <div className="clearfix d-block w-100 theme-pt-10"></div>
                                                            <ul>
                                                                <li>
                                                                    <i className="mdi mdi-speedometer"></i>
                                                                    {
                                                                        item.mileage ?
                                                                            <NumericFormat
                                                                                value={item.mileage}
                                                                                displayType={'text'}
                                                                                thousandSeparator="."
                                                                                decimalSeparator=","
                                                                                decimalScale={0}
                                                                                fixedDecimalScale={true}
                                                                                suffix=' km' />
                                                                            : ' - km'
                                                                    }
                                                                </li>
                                                                <li><i className="mdi mdi-car-shift-pattern"></i>{item.transmission}</li>
                                                                <li><i className="mdi mdi-gas-station"></i>{item.fuel}</li>
                                                                <li><i className="mdi mdi-car-door"></i>{item.doors ? `${item.doors} Portas` : 'n/i'}</li>
                                                            </ul>
                                                            <a href={adLink} title={adTitle} className="btn outline-btn btn-sm d-block">VER MAIS DETALHES</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            })
                                            : <div className="col-md-12">
                                                <div className="alert alert-warning">Nenhum veículo encontrado, faça outro filtro e tente novamente.</div>
                                            </div>
                                    }
                                </div>
                                {
                                    ads.paginationOut.totalRows > 18
                                        ? <div className="row">
                                            <div className="col-md-12 text-left">
                                                <ReactPaginate
                                                    forcePage={page ? parseInt(page) : 0}
                                                    className="pagination"
                                                    activeClassName="active"
                                                    breakLabel="..."
                                                    nextLabel={<img src="fonts/fi-rr-arrow-small-rightw.svg" alt="Próxima página" title="Próxima página" />}
                                                    onPageChange={handlePageClick}
                                                    pageRangeDisplayed={5}
                                                    pageCount={pageCount}
                                                    previousLabel={<img src="fonts/fi-rr-arrow-small-leftw.svg" alt="Página anterior" title="Página anterior" />}
                                                    renderOnZeroPageCount={null}
                                                />
                                            </div>
                                        </div>
                                        : null
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}